module.exports = __webpack_public_path__ + "static/media/league-white.8947eb1c.svg";